import { Image } from 'react-native';
import createAnimatedComponent from '../../createAnimatedComponent';
const AnimatedImage = createAnimatedComponent(Image);
export default AnimatedImage;
